import { Component, OnInit, OnDestroy } from '@angular/core';
import { IndustryService } from '../services/industry.service'

import { fadeInUp } from '../services/animations/fadeInUp.animation'

@Component({
    selector: 'app-industries',
    templateUrl: './industries.component.html',
    animations: [fadeInUp]
})
export class IndustriesPageComponent implements OnInit, OnDestroy {

    // Template Variables
    courseCount: any
    industries: any = []
    industriesSubscription: any
    courseCountSubscription: any


    constructor(
        private industryService: IndustryService
    ) { }

    ngOnInit() {
        this.industryService.getCourseCount()
        this.courseCountSubscription = this.industryService.CourseCount.subscribe(courseCount => {
            if (courseCount) {
                this.courseCount = courseCount
            }
        })

        this.industryService.getIndustries()
        this.industriesSubscription = this.industryService.Industries.subscribe(industries => {
            if (industries && industries.length > 0) {
                this.industries = industries
            }
        })
    }

    ngOnDestroy() {
        if (this.industriesSubscription) {
            this.industriesSubscription.unsubscribe()
        }
        if (this.courseCountSubscription) {
            this.courseCountSubscription.unsubscribe()
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/industries/industries.component.ts